import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@app/material.module';
import { RequestsSharedModule } from '../requests/@shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { LogaltyConsentsModule } from '@app/requests/logalty-digital-signature/logalty-consents/logalty-consents.module';
import { LogaltySignatureModule } from '@app/requests/logalty-digital-signature/logalty-signature/logalty-signature.module';
import { SharedModule } from '@app/@shared';
import { ThridPartySignatureComponent } from './third-party-signature.component';
import { LogaltySignatureEkipRoutingModule } from './third-party-signature-routing.module';
import { I18nModule } from '@app/i18n';

@NgModule({
  declarations: [ThridPartySignatureComponent],
  imports: [
    CommonModule,
    LogaltySignatureEkipRoutingModule,
    RequestsSharedModule,
    MaterialModule,
    FlexLayoutModule,
    SharedModule,
    I18nModule,
    LogaltyConsentsModule,
    LogaltySignatureModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ThridPartySignatureModule {}
